import React, { PropTypes } from 'react';
import ProgressBar from '../common/ProgressBar';
import { isUndefinedNullOrEmpty } from '../../js/utils';

const ImageCreateProgress = React.createClass({
    propTypes: {
        imageCreationProgress: PropTypes.object
    },
    render() {
        const percentage = !isUndefinedNullOrEmpty(this.props.imageCreationProgress) ?
            Math.round(this.props.imageCreationProgress.percentage) :
            0;

        return <div className="pure-u-1-1">
            <h3>Creating your image...</h3>
            <ProgressBar percent={percentage} />
            <div>{percentage}%</div>
        </div>;
    }
});

export default ImageCreateProgress;



// WEBPACK FOOTER //
// ./src/components/dashboard/ImageCreateProgress.jsx